import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../header";
import EventRender from "./EventRender";
import Footer from "../footer";
import PageTitle from "../theme/components/pagetitle";
import Loader from "../loader";
import {t} from "@lingui/core/macro";

export default class Events extends Component{
    render(){
        if(this.props.loading){
            return (
                <div>
                    <Loader/>
                </div>
            )
        }

        const context=this.props.context
        const {org,config}=context
        const title=  t`Événements de ${org.name}`
        const description=  t`Événements de ${org.name}`

        return(
            <div>
                <Meta context={context} title={title} description={description}/>
                <Header context={context}/>
                <PageTitle context={context} title={t`Événements`} color="#05a5d1"/>
                <div style={{marginTop: 0,minHeight:"50vh"}}>
                    <EventRender context={context}/>
                </div>
                <Footer context={context}/>
            </div>
        )
    }
}
